/*
 * nc-campaign-price.js
 * Code campaigns (CAMPAIGNS below: Oferta Halloween HALLOWEEN26 −25% until
 * Black Month BLACK26 −30%… takes over at Mon 2.11 00:00) — puts the campaign
 * code on the visitor's cart and shows strikethrough promo pricing on ONE-TIME
 * prices of the products the code covers (collection tiles, search cards, PDP
 * one-time tab; the PDP CTA follows through percentFor() in
 * nc-product-buy-button). Subscription pricing is never touched.
 *
 * BEHAVIOR (per marketing):
 *   • Auto-apply: a visitor whose cart has no discount code gets
 *     CONFIG.autoApply, once per browser session (cookie), so someone who
 *     removes it in the drawer isn't handed it again on the next page. Codes
 *     left on carts by ended campaigns (CONFIG.staleCodes) count as no code.
 *     Campaign LPs that apply their own code ([data-lp-discount]) are skipped.
 *   • The strikethrough appears ONLY while a campaign code is on the cart and
 *     working. Shopify marks a code inapplicable on a cart with nothing it
 *     covers (an empty cart right after the auto-apply) — that code is waiting,
 *     not refused, unless another code applies instead. The percent is read
 *     from that code, so the shown price matches what checkout will charge.
 *   • Remove the code (or apply a non-campaign code) → prices revert to normal.
 *   • PDPs of covered products arrive with the promo already drawn by Liquid
 *     (snippets/nc-campaign.liquid → buy-button tab, CTA, header, bottom bar,
 *     og:price, JSON-LD): Google checks the feed's sale price against the page
 *     as its crawler sees it. Server-drawn nodes carry data-nc-plain (their
 *     regular markup); the script keeps the promo until the cart rules it out
 *     (another code, or this one removed) and then puts data-nc-plain back.
 *
 * WHY CLIENT-SIDE: Shopify only evaluates codes in the cart/checkout, so we
 * mirror the maths for the code on the cart (read from /cart.js).
 *
 * SOURCE OF TRUTH: /cart.js `discount_codes`. The drawer (nc-cart-drawer.js)
 * dispatches `cart:updated` after every mutation, including code apply/remove.
 *
 * Omnibus (PL): a code-driven "promo" strikethrough may carry lowest-30-day-price
 * obligations — confirm with whoever owns pricing compliance.
 *
 * To disable: enabled: false on the campaign, or remove the <script> include
 * in layout/theme.liquid. The campaign is picked once per page load.
 */
(function () {
  if (window.__ncCampaignPrice) return; // idempotent
  window.__ncCampaignPrice = true;

  // Keep in step with snippets/nc-campaign.liquid (the server-side half). The
  // first campaign whose window holds the visitor's clock runs.
  var CAMPAIGNS = [
    {
      // Black Month 2026 (/pages/black-friday). BLACK26 is the tiered code
      // (natu-discounts app): −30% from the first item, up to −50% by cart
      // size — the struck prices show the −30% everyone gets.
      enabled: true,
      activeFrom: '2026-11-02T00:00:00+01:00',
      activeUntil: '2026-12-01T00:00:00+01:00',
      codes: { BLACK26: 30 },
      autoApply: 'BLACK26',
      staleCodes: ['NATALIA', 'TROSKA', 'TESTER', 'HALLOWEEN26'],
      promoCollection: '' // every product
    },
    {
      // Oferta Halloween (its admin window runs to 2.11 18:30; Black Month
      // takes the site over at midnight).
      enabled: true,
      activeFrom: '2026-10-26T18:23:00+01:00',
      activeUntil: '2026-11-02T00:00:00+01:00',
      codes: { HALLOWEEN26: 25 },
      autoApply: 'HALLOWEEN26',
      staleCodes: ['NATALIA', 'TROSKA', 'TESTER'],
      promoCollection: 'natu-care-copy'
    }
  ];
  // Fields: activeFrom/activeUntil = the code's window (ISO, with offset);
  // codes = code (UPPERCASE) → percent off the one-time price; autoApply = put
  // on carts with no code ('' = off); staleCodes = codes ended campaigns left
  // on carts, counted as no code; promoCollection = the code's scope, read from
  // the collection's products.json (Liquid's product.collections is unreliable
  // for products in many collections), '' = every product.
  var CONFIG = CAMPAIGNS.filter(function (c) {
    var now = Date.now();
    return c.enabled && now >= Date.parse(c.activeFrom) && now < Date.parse(c.activeUntil);
  })[0] || CAMPAIGNS[CAMPAIGNS.length - 1];

  // ---- campaign window --------------------------------------------------------
  function withinWindow() {
    var now = Date.now();
    if (CONFIG.activeFrom && now < Date.parse(CONFIG.activeFrom)) return false;
    if (CONFIG.activeUntil && now >= Date.parse(CONFIG.activeUntil)) return false;
    return true;
  }
  function on() { return CONFIG.enabled && withinWindow(); }

  // ---- code helpers ----------------------------------------------------------
  function normalize(code) { return String(code || '').trim().toUpperCase(); }
  function percentForCode(code) { return CONFIG.codes[normalize(code)] || 0; }
  function higher(a, b) { return percentForCode(a) >= percentForCode(b) ? a : b; }

  // ---- money formatting (match the theme's `| money` output) -----------------
  var plnFallback = null;
  function fmt(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney &&
          window.shopSettings && window.shopSettings.moneyFormat) {
        return theme.Currency.formatMoney(cents, window.shopSettings.moneyFormat);
      }
    } catch (e) { /* fall through */ }
    if (!plnFallback) {
      plnFallback = new Intl.NumberFormat('pl-PL', {
        style: 'currency', currency: 'PLN', minimumFractionDigits: 2
      });
    }
    return plnFallback.format(cents / 100);
  }

  // Shopify takes the discount off each unit, rounded DOWN to the grosz
  // (checked on the live cart: 19,90 −25% → 14,93).
  function discountedCents(baseCents, pct) {
    return baseCents - Math.floor((baseCents * pct) / 100);
  }

  // ---- eligibility (which products the promo applies to) ---------------------
  // Ground truth = the promo collection's actual product list, fetched from
  // Shopify's JSON endpoint and matched by product handle. This sidesteps the
  // unreliable Liquid product.collections. Cached per session so it's fetched once.
  var eligibleHandles = null; // Set<handle>; null until loaded → nothing decorated
  var ELIGIBLE_KEY = 'nc_campaign_eligible_' + CONFIG.promoCollection;
  var EVERY_PRODUCT = { has: function (handle) { return !!handle; } };

  function isEligible(el) {
    var h = el.getAttribute('data-nc-handle');
    if (!eligibleHandles) return !!h && h === serverHandle; // list not loaded yet
    return !!h && eligibleHandles.has(h);
  }

  function loadEligible() {
    if (!CONFIG.promoCollection) { eligibleHandles = EVERY_PRODUCT; return; }
    try {
      var cached = window.sessionStorage.getItem(ELIGIBLE_KEY);
      if (cached) { eligibleHandles = new Set(JSON.parse(cached)); return; }
    } catch (e) { /* ignore */ }
    fetchEligible(1, []);
  }

  // Page through /collections/<handle>/products.json until an empty page (robust
  // to whatever page size Shopify enforces). On failure we leave eligibleHandles
  // null → no promo shown, which is the safe default (never a price we can't honor).
  function fetchEligible(page, acc) {
    fetch('/collections/' + CONFIG.promoCollection + '/products.json?limit=250&page=' + page,
          { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var list = (data && data.products) || [];
        for (var i = 0; i < list.length; i++) {
          if (list[i] && list[i].handle) acc.push(list[i].handle);
        }
        if (list.length > 0 && page < 20) {
          fetchEligible(page + 1, acc);
        } else {
          eligibleHandles = new Set(acc);
          try { window.sessionStorage.setItem(ELIGIBLE_KEY, JSON.stringify(acc)); } catch (e) {}
          resolve(); // eligibility now known — (re)decide and draw
        }
      })
      .catch(function () { /* leave null → no promo shown */ });
  }

  // ---- state -----------------------------------------------------------------
  // pct > 0 only while a campaign code is on the cart and working. suppressed =
  // show plain prices (the default, and whenever no campaign code is working).
  var state = { code: '', pct: 0 };
  var suppressed = true;
  var lastCart = null;
  var autoPending = false; // auto-apply sent, but the cart didn't come back with it

  // A PDP whose promo Liquid already drew ([data-nc-campaign-pct] on the one-time
  // tab) starts with the promo on, before the cart is read — the buy-button
  // prices its CTA from percentFor() on DOMContentLoaded.
  var serverPct = null;
  var serverHandle = '';
  function seed() {
    if (serverPct !== null || document.readyState === 'loading') return;
    var el = document.querySelector('[data-nc-campaign-pct]');
    serverPct = el ? parseInt(el.getAttribute('data-nc-campaign-pct'), 10) || 0 : 0;
    if (!serverPct) return;
    serverHandle = el.getAttribute('data-nc-handle') || '';
    if (!lastCart) {
      state.code = normalize(CONFIG.autoApply);
      state.pct = serverPct;
      suppressed = false;
    }
  }

  // Percent off the one-time price of this product right now (0 = none).
  function percentFor(handle) {
    seed();
    if (!on() || suppressed) return 0;
    if (eligibleHandles ? !eligibleHandles.has(handle) : handle !== serverHandle) return 0;
    return state.pct;
  }

  // ---- rendering -------------------------------------------------------------
  // Every node we mutate is stashed with its original HTML so we can fully
  // restore the plain price the moment the code is removed.
  var decorated = [];
  function stash(el) {
    if (el.__ncStashed) return;
    el.__ncStashed = true;
    // A server-drawn node already shows the promo — its plain markup is data-nc-plain.
    var plain = el.getAttribute('data-nc-plain');
    decorated.push({ el: el, html: plain !== null ? plain : el.innerHTML });
  }
  function restore() {
    for (var i = 0; i < decorated.length; i++) {
      var d = decorated[i];
      d.el.innerHTML = d.html;
      d.el.removeAttribute('data-nc-campaign');
      d.el.__ncStashed = false;
    }
    decorated.length = 0;
    // Server-drawn nodes we never redrew (and any a v3 swap just copied in).
    var nodes = document.querySelectorAll('[data-nc-plain][data-nc-campaign]');
    for (var j = 0; j < nodes.length; j++) toPlain(nodes[j]);
  }
  // Server-drawn node → its regular markup; the promo markup is kept to redraw it.
  function toPlain(el) {
    if (!el || !el.hasAttribute('data-nc-plain') || !el.hasAttribute('data-nc-campaign')) return;
    el.__ncPromo = el.innerHTML;
    el.innerHTML = el.getAttribute('data-nc-plain');
    el.removeAttribute('data-nc-campaign');
  }
  // …and back, once the code works again (protokół price; the tab is redrawn by renderPdp).
  function renderServer() {
    var nodes = document.querySelectorAll('[data-nc-plain]:not([data-nc-campaign])');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.__ncPromo === undefined || el.__ncStashed || state.pct !== serverPct) continue;
      el.innerHTML = el.__ncPromo;
      el.setAttribute('data-nc-campaign', '1');
    }
  }
  // One node only: put its plain price back, or (keepCurrent) just drop our
  // record because its markup was already replaced by someone else.
  function restoreOne(el, keepCurrent) {
    for (var i = decorated.length - 1; i >= 0; i--) {
      if (decorated[i].el !== el) continue;
      if (!keepCurrent) el.innerHTML = decorated[i].html;
      el.removeAttribute('data-nc-campaign');
      el.__ncStashed = false;
      decorated.splice(i, 1);
    }
  }

  var STYLE_ID = 'nc-campaign-price-style';
  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '.nc-campaign-was{text-decoration:line-through;color:#a3a3a3;font-weight:400;margin-right:.5rem;}' +
      '.nc-campaign-now{font-weight:bold;color:#F37B5B;font-size:1.4rem;}' +
      // Give the tabs room for the extra struck-price line — only while the
      // promo is on (class toggled in paint()); reverts to the theme's 4.4rem.
      '.purchase-options.nc-campaign-active .purchase-options_tab{height:6rem;}';
    document.head.appendChild(s);
  }

  // Collection tiles: <div class="nc-product-tile_priceLine" data-nc-otp="10000">.
  // Tiles of products with subscription plans show "Od <subscription price>";
  // while the code works they switch to the struck one-time price it gives.
  function renderTiles() {
    var nodes = document.querySelectorAll('.nc-product-tile_priceLine[data-nc-otp]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isEligible(el)) continue; // only products in the promo collection
      var base = parseInt(el.getAttribute('data-nc-otp'), 10);
      if (!isFinite(base) || base <= 0) continue;
      var now = discountedCents(base, state.pct);
      stash(el);
      el.innerHTML =
        '<span class="nc-product-tile_price nc-product-tile_price--beforeDiscount">' + fmt(base) + '</span>' +
        '<span class="nc-product-tile_price nc-product-tile_price--sale nc-campaign-now">' + fmt(now) + '</span>';
      el.setAttribute('data-nc-campaign', '1');
    }
  }

  // Search / simple cards: <div class="nc-product-price" data-nc-otp="10000">
  function renderCards() {
    var nodes = document.querySelectorAll('.nc-product-price[data-nc-otp]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isEligible(el)) continue; // only products in the promo collection
      var base = parseInt(el.getAttribute('data-nc-otp'), 10);
      if (!isFinite(base) || base <= 0) continue;
      var now = discountedCents(base, state.pct);
      stash(el);
      el.innerHTML =
        '<span class="nc-campaign-was">' + fmt(base) + '</span>' +
        '<span class="nc-campaign-now">' + fmt(now) + '</span>';
      el.setAttribute('data-nc-campaign', '1');
    }
  }

  // PDP one-time tab only. data-price is major units ("100.00"); we keep the
  // per-serving sub-span (.purchase-options_tab-price-day) intact.
  // aov-pdp-v3 flavor/dose/duration swaps replace the tab's markup in place and
  // copy over the new product's data-nc-otp / data-nc-handle (copyTabPrice).
  function renderPdp() {
    var el = document.querySelector('.purchase-options_tab--onetime .purchase-options_tab-price');
    if (!el) return;
    var label = document.querySelector('.purchase-options_tab--onetime .purchase-options_tab-label');
    // Swapped since (aov-pdp-v3 copies the new product's tab in): forget the old
    // record; a server-drawn tab brings its own data-nc-plain.
    if (el.__ncStashed && (!el.querySelector('.nc-campaign-now') || el.hasAttribute('data-nc-plain'))) restoreOne(el, true);
    if (!isEligible(el)) { // product not in the promo collection
      toPlain(el);
      if (label) { restoreOne(label); toPlain(label); }
      return;
    }
    var base = parseInt(el.getAttribute('data-nc-otp'), 10); // exact cents from Liquid
    if (!isFinite(base) || base <= 0) {
      var major = parseFloat(String(el.getAttribute('data-price') || '').replace(',', '.'));
      if (!isFinite(major)) return;
      base = Math.round(major * 100);
    }
    var now = discountedCents(base, state.pct);
    stash(el);
    var sub = el.querySelector('.purchase-options_tab-price-day');
    // clear everything except the per-serving sub-span
    var kids = Array.prototype.slice.call(el.childNodes);
    for (var i = 0; i < kids.length; i++) {
      if (kids[i] !== sub) el.removeChild(kids[i]);
    }
    var wasEl = document.createElement('span');
    wasEl.className = 'nc-campaign-was';
    wasEl.textContent = fmt(base);
    var nowEl = document.createElement('span');
    nowEl.className = 'nc-campaign-now';
    nowEl.textContent = fmt(now);
    el.insertBefore(nowEl, sub || null);
    el.insertBefore(wasEl, nowEl);
    el.setAttribute('data-nc-campaign', '1');

    // reflect the discount on the tab label, e.g. "Zakup jednorazowy (-25%)"
    if (label) {
      stash(label);
      var txt = (label.textContent || '').replace(/\s*\(-\d+%\)\s*$/, '').trim();
      label.textContent = txt + ' (-' + state.pct + '%)';
    }
  }

  function render() {
    ensureStyle();
    renderServer();
    renderTiles();
    renderCards();
    renderPdp();
  }

  // Single entry point: draw the strikethrough for the working code, or restore
  // plain prices when no campaign code is working on the cart.
  function paint() {
    if (!on()) return;
    if (suppressed) restore();
    else render();
    markTabs();
    // The PDP's own price outputs (CTA) re-read percentFor() on this.
    document.dispatchEvent(new CustomEvent('nc-campaign-price:change'));
  }

  // Taller PDP tabs only when the one-time tab actually got the strikethrough
  // (i.e. a code is working AND the product is eligible). No-op off-PDP.
  function markTabs() {
    var po = document.querySelector('.purchase-options');
    if (po) {
      var decoratedTab = document.querySelector(
        '.purchase-options_tab--onetime .purchase-options_tab-price[data-nc-campaign]'
      );
      po.classList.toggle('nc-campaign-active', !!decoratedTab);
    }
  }

  // ---- detection -------------------------------------------------------------
  // The campaign code working on this cart ('' = none): applicable, or waiting —
  // inapplicable only because no eligible one-time line is in the cart yet, with
  // no other code applying instead.
  function workingCode(cart) {
    var list = (cart && cart.discount_codes) || [];
    var items = (cart && cart.items) || [];
    var otherApplies = list.some(function (dc) {
      return dc && dc.applicable && !percentForCode(dc.code);
    });
    var coveredLine = items.some(function (item) {
      return !item.selling_plan_allocation && !!eligibleHandles && eligibleHandles.has(item.handle);
    });
    var applied = '';
    for (var i = 0; i < list.length; i++) {
      var dc = list[i];
      var code = normalize(dc && dc.code);
      if (!percentForCode(code)) continue;
      var waiting = dc.applicable === false && !otherApplies && !coveredLine;
      if (dc.applicable !== false || waiting) applied = higher(applied, code);
    }
    return applied;
  }

  // Decide from the last cart read. Apart from a server-drawn PDP (seed), this
  // is the only thing that turns the promo on, so it never shows a code the
  // cart doesn't carry — and it takes a server-drawn promo down when it doesn't.
  function resolve() {
    // Eligibility can land before the cart: keep the starting state (plain, or
    // the server-drawn promo) until a cart has been read.
    if (!lastCart) { paint(); return; }
    var code = workingCode(lastCart);
    // The auto-apply request failed (or a crawler's renderer dropped it): the
    // code is still what this visitor gets, so keep showing it.
    if (!code && autoPending) code = normalize(CONFIG.autoApply);
    suppressed = !code;
    if (code) { state.code = code; state.pct = percentForCode(code); }
    paint();
  }

  // ---- auto-apply --------------------------------------------------------------
  var AUTO_COOKIE = 'nc_campaign_auto';

  function shouldAutoApply(cart) {
    var code = CONFIG.autoApply;
    if (!code || !cart) return false;
    if (document.querySelector('[data-lp-discount]')) return false; // the LP applies its own
    if (document.cookie.split('; ').indexOf(AUTO_COOKIE + '=' + code) !== -1) return false;
    return (cart.discount_codes || []).every(function (dc) {
      return CONFIG.staleCodes.indexOf(normalize(dc && dc.code)) !== -1;
    });
  }

  // `discount` on /cart/update.js replaces the cart's codes — only the stale
  // ones are there by now. No expiry on the cookie = this browser session.
  function autoApply() {
    document.cookie = AUTO_COOKIE + '=' + CONFIG.autoApply + '; path=/; SameSite=Lax';
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: CONFIG.autoApply })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        // The drawer was rendered before the code landed; a cart with items
        // now has new totals in it.
        if (cart && cart.item_count > 0 && window.NcCartDrawer && NcCartDrawer.refresh) {
          NcCartDrawer.refresh();
        }
        return cart;
      })
      .catch(function () { return null; });
  }

  function detectFromCart() {
    try {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!shouldAutoApply(cart)) return cart;
          return autoApply().then(function (updated) {
            if (!updated) autoPending = true;
            return updated || cart;
          });
        })
        .then(function (cart) {
          lastCart = cart;
          resolve();
        })
        .catch(function () { /* no-op */ });
    } catch (e) { /* no-op */ }
  }

  // Coalesce bursts of cart events into one /cart.js read, with a second pass to
  // catch a discount that lands just after its event.
  var detectTimer = null;
  function scheduleDetect() {
    clearTimeout(detectTimer);
    detectTimer = setTimeout(function () {
      detectFromCart();
      setTimeout(detectFromCart, 800);
    }, 350);
  }

  // ---- public API + wiring ---------------------------------------------------
  window.ncCampaignPrice = {
    config: CONFIG,
    active: withinWindow,
    state: state,
    percentFor: percentFor,
    discountedCents: discountedCents,
    detect: detectFromCart,
    refresh: paint // call after AJAX injects new tiles (filters/pagination)
  };

  function boot() {
    seed();
    if (!on()) { restore(); markTabs(); return; } // a page cached past activeUntil: plain prices
    loadEligible();   // fetch which products are in the promo collection (cached)
    detectFromCart(); // auto-apply if the cart has no code, then draw
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Cart changed — a discount code may have been applied, changed, or removed.
  // The cart dispatches cart:updated after every mutation.
  document.addEventListener('cart:updated', function () { if (on()) scheduleDetect(); });

  // PDP variant switch: base one-time price changes → recompute from the variant.
  document.addEventListener('variant:change', function (e) {
    if (!on()) return;
    var v = e.detail && e.detail.variant;
    var el = document.querySelector('.purchase-options_tab--onetime .purchase-options_tab-price');
    if (v && typeof v.price === 'number' && el) {
      el.setAttribute('data-nc-otp', v.price); // new base for renderPdp
    }
    paint();
  });
})();
